import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const ADD_DOCTOR = "create";
const DELETE_DOCTOR = "delete";
const GET_DOCTOR = "get";
const EDIT_DOCTOR = "edit";

export default {
  createDoctor(payload) {
    return Repository.post(transformRoute(ADD_DOCTOR), payload);
  },
  deleteDoctor(payload) {
    return Repository.post(transformRoute(DELETE_DOCTOR), payload);
  },
  getDoctor(payload) {
    return Repository.post(transformRoute(GET_DOCTOR), payload);
  },
  editDoctor(payload) {
    return Repository.post(transformRoute(EDIT_DOCTOR), payload);
  },
};

const transformRoute = (route) => {
  return `cms/doctor/${route}`;
};
